import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pof_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Resolve an image_url that may be a backend-relative path or an absolute URL
export const resolveImg = (url) => {
  if (!url) return null;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

export const fetchMenuItems = async () => {
  const { data } = await axios.get(`${API}/menu-items`);
  return data;
};

export const createMenuItem = (payload) => api.post("/menu-items", payload).then((r) => r.data);
export const updateMenuItem = (id, payload) => api.put(`/menu-items/${id}`, payload).then((r) => r.data);
export const deleteMenuItem = (id) => api.delete(`/menu-items/${id}`).then((r) => r.data);
export const fetchBookings = () => api.get("/bookings").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const forgotPassword = (email) =>
  axios.post(`${API}/auth/forgot-password`, { email }).then((r) => r.data);
export const resetPassword = (token, new_password) =>
  axios.post(`${API}/auth/reset-password`, { token, new_password }).then((r) => r.data);

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.image_url;
};
